/**
 * What this machine looks like, for the server to class it.
 *
 * Static signals only, sent once with the policy request. The browser reports;
 * it does not decide — see ./index.js. Everything here degrades to "did not
 * say": navigator.deviceMemory and performance.memory are Chrome-only and
 * non-standard, and the web surface is not always Chrome. A missing signal must
 * never read as a small number, which is why nothing below substitutes a
 * default.
 *
 * There is deliberately no runtime memory watchdog here. performance.memory
 * reports the heap of the process it runs in, and this document — a side panel
 * or a cross-origin iframe — is a different renderer process from the EMR tab,
 * so a watchdog here could never see the memory that makes a clinic machine
 * slow. The recorder's own buffer ceiling is the runtime bound.
 */

/** Static signals for the policy call. Absent fields are simply left out. */
export function collectDeviceProfile() {
  const profile = {};
  try {
    if (typeof navigator !== 'undefined') {
      if (Number.isFinite(navigator.deviceMemory)) {
        profile.deviceMemory = navigator.deviceMemory;
      }
      if (Number.isFinite(navigator.hardwareConcurrency)) {
        profile.hardwareConcurrency = navigator.hardwareConcurrency;
      }
    }
    const limit = heapLimitBytes();
    if (limit) profile.jsHeapLimitMb = Math.round(limit / 1048576);
  } catch (e) {
    // A profile is an optimisation; failing to build one must not stop a replay.
    console.log('replay: could not read device profile', e);
  }
  return profile;
}

function heapLimitBytes() {
  // performance.memory is Chrome-only and deprecated in favour of
  // measureUserAgentSpecificMemory(), which needs cross-origin isolation we do
  // not have. Where it is missing the profile simply omits the field.
  const memory = typeof performance !== 'undefined' ? performance.memory : null;
  return memory && memory.jsHeapSizeLimit ? memory.jsHeapSizeLimit : 0;
}
